import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../../components/Navbar';

const PaymentVerification: React.FC = () => {
    const [status, setStatus] = useState<'verifying' | 'success' | 'error'>('verifying');
    const [message, setMessage] = useState('Verifying your payment...');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const verifyPayment = async () => {
            try {
                // Look for order_id in query params. 
                // INRPORTAL typically appends query params on redirect or uses a POST form redirect.
                // We'll support order_id from query params.
                const searchParams = new URLSearchParams(location.search);
                const orderId = searchParams.get('order_id') || searchParams.get('orderId') || searchParams.get('id');

                if (!orderId) {
                    setStatus('error');
                    setMessage('Order ID missing from redirect. Please check your dashboard for status updates.');
                    setTimeout(() => {
                        navigate('/customer/dashboard');
                    }, 4000);
                    return;
                }

                const response = await axios.post('/api/warranty/verify-payment', { orderId });

                if (response.data.status === 'SUCCESS' || response.data.status === 'COMPLETED') {
                    setStatus('success');
                    setMessage('Payment verified successfully! Your warranty is now active.');
                    setTimeout(() => {
                        navigate('/customer/dashboard');
                    }, 3000);
                } else {
                    setStatus('error');
                    setMessage(`Payment status: ${response.data.status || 'Pending/Failed'}. Check your dashboard later.`);
                    setTimeout(() => {
                        navigate('/customer/dashboard');
                    }, 4000);
                }
            } catch (err: any) {
                console.error('Payment verification error:', err);
                setStatus('error');
                setMessage(err.response?.data?.error || 'Failed to verify payment. Please check your dashboard later.');
                setTimeout(() => {
                    navigate('/customer/dashboard');
                }, 4000);
            }
        };

        // Use a small delay before verifying to let backend process webhooks if they arrived simultaneously
        const timer = setTimeout(() => {
            verifyPayment();
        }, 1500);

        return () => clearTimeout(timer);
    }, [location, navigate]);

    return (
        <>
            <Navbar />
            <div className="container" style={{ textAlign: 'center', padding: '60px 20px' }}>
                <div className="card" style={{ maxWidth: '500px', margin: '0 auto', padding: '40px' }}>
                    {status === 'verifying' && (
                        <>
                            <h2>Processing Payment...</h2>
                            <div className="loading" style={{ margin: '20px auto' }}></div>
                            <p style={{ color: '#666' }}>{message}</p>
                        </>
                    )}
                    {status === 'success' && (
                        <>
                            <h2 style={{ color: '#28a745' }}>✅ Success!</h2>
                            <p style={{ margin: '20px 0', fontSize: '18px' }}>{message}</p>
                            <p style={{ color: '#666' }}>Redirecting to dashboard...</p>
                        </>
                    )}
                    {status === 'error' && (
                        <>
                            <h2 style={{ color: '#dc3545' }}>⚠️ Notice</h2>
                            <p style={{ margin: '20px 0', fontSize: '18px' }}>{message}</p>
                            <p style={{ color: '#666' }}>Redirecting to dashboard in a few seconds...</p>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default PaymentVerification;
